import { getSupportedLocale } from '../../../utilities/locale';

export default getSupportedLocale;
